/* eslint-disable react/no-unknown-property */
/* eslint-disable no-unused-vars */
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Reusable Components
import SubTitleContents from "reusables/TextFormats/SubTitleContents";
import UnNumberedList from "reusables/TextFormats/UnNumberedList";
import Email from "reusables/Contact/Email";

// Images

function Operational_Section1() {
  const lineSpacing_lg = <MKBox mb={12} />;
  const lineSpacing_sm = <MKBox mb={2} />;

  return (
    <Container>
      <Grid
        container
        alignItems="center"
        // bgcolor={"red"}
        width={"100%"}
      >
        <Grid item xs={12}>
          <SubTitleContents
            title=""
            contents={
              <>
                At Spechs Property Services, we ensure that our Quality Policy is effectively
                communicated to all staff members and reviewed annually to maintain its relevance
                and alignment with the company’s purpose. The company’s Quality Management System is
                fully authorised by the management team, and adherence to its policies and
                procedures is mandatory for all staff.
              </>
            }
          />
          {lineSpacing_lg}
          <SubTitleContents
            title="Managers"
            contents={
              <>
                <MKBox mb={2} />
                <UnNumberedList
                  items={[
                    "Oversee the facility and hygiene management services provided to our clients.",
                    "Ensure operational and managerial compliance with statutory and mandatory requirements.",
                    "Act as specialist advisors on all aspects of hygiene and cleaning management solutions for clients.",
                  ]}
                />
              </>
            }
          />
          {lineSpacing_lg}
          <SubTitleContents
            title="Supervisors"
            contents={
              <>
                <MKBox mb={2} />
                <UnNumberedList
                  items={[
                    "Organise staff and prepare cleaning rosters.",
                    "Manage and replenish cleaning supplies, maintaining supplier documentation.",
                    "Address supplier issues and report to Managers.",
                    "Monitor and assess the quality of cleaning standards.",
                    "Ensure adherence to standards (uniforms, training).",
                    "Record and submit timesheets weekly to Managers.",
                    "Track additional hours for billing purposes.",
                    "Provide staff coverage for holidays and sick leave.",
                    "Liaise with customers, addressing feedback as necessary.",
                    "Lead and support the continuous improvement programme.",
                  ]}
                />
              </>
            }
          />
          {lineSpacing_lg}
          <SubTitleContents
            title="Team Members"
            contents={
              <>
                <MKBox mb={2} />
                <UnNumberedList
                  items={[
                    "Follow the agreed work schedule.",
                    "Wear uniforms and PPE as provided.",
                    "Adhere to all quality procedures and work instructions.",
                    "Maintain required standards in line with Cleaning Specifications and guidelines.",
                    "Participate in training as required.",
                    "Observe punctuality and respect customer-specific requirements.",
                    "Liaise with customers, relaying feedback to supervisors.",
                  ]}
                />
              </>
            }
          />
          {lineSpacing_lg}
        </Grid>
      </Grid>
    </Container>
  );
}

export default Operational_Section1;
